export function normaliseBetweenTwoRanges(
	val: number,
	minVal: number,
	maxVal: number,
	newMin: number,
	newMax: number,
): number {
	const result =
		newMin + ((val - minVal) * (newMax - newMin)) / (maxVal - minVal);
	return Math.round((result + Number.EPSILON) * 100) / 100;
}
